<template>
  <div>
    <b-form-group>
      <label>Chiết khấu</label>
      <b-input-group>
        <template #append>
          <b-button
            size="sm"
            style="width: 40px"
            variant="secondary"
            @click="onChangeDiscountType"
          >
            <i
              v-if="selectDiscountType === 2"
              class="fa fa-percent"
              aria-hidden="true"
            ></i>
            <i v-else class="fas fa-dollar-sign" aria-hidden="true"></i>
          </b-button>
        </template>
        <template class="relative">
          <b-form-input
            size="sm"
            class="text-right"
            id="input-discount"
            v-model="orderDiscount.discountAmount"
            @change="onChangeDiscountAmount"
            :min="1"
            v-mask="mask"
            autocomplete="off"
          ></b-form-input>
          <label class="absolute text-primary">{{
            selectDiscountType === 2 ? 'Phần trăm' : 'Tiền mặt'
          }}</label>
        </template>
      </b-input-group>
    </b-form-group>
    <!-- <b-form-group :disabled="id ? true : false">
      <label>Mã coupon:</label>
      <b-input-group>
        <b-form-input
          class="input-style"
          size="sm"
          v-model="orderDiscount.couponCode"
          placeholder="Nhập mã coupon"
          @change="onChangeCouponCode()"
          :disabled="isCouponApplied"
          autocomplete="off"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            v-if="!isCouponApplied"
            style="width: 40px"
            @click="checkCoupon()"
            variant="secondary"
            size="sm"
            :disabled="isCheckingCoupon"
          >
            <i v-if="isCheckingCoupon" class="fas fa-spinner fa-spin"></i>
            <i v-else class="fas fa-sync"></i>
          </b-button>
          <b-button
            v-else
            style="width: 40px"
            @click="removeCoupon()"
            variant="danger"
            size="sm"
            title="Hủy coupon"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <small v-if="appliedCouponInfo" class="text-success mt-1 d-block">
        <i class="fas fa-check-circle"></i>
        {{ appliedCouponInfo.name }} - Áp dụng thành công
      </small>
    </b-form-group> -->
    <b-form-group v-if="customerInfo.customerId">
      <label>Tiêu điểm: </label>
      <b-input-group>
        <b-form-input
          class="input-style text-right"
          size="sm"
          v-model="orderDiscount.subtractPoint"
          placeholder="Nhập số điểm"
          type="number"
          min="0"
          :max="customerInfo.totalPoint || 0"
          autocomplete="off"
          @input="onPointsInput"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            style="width: 40px"
            variant="secondary"
            size="sm"
            @click="applyCustomerPoints()"
            :disabled="
              isApplyingPoints ||
              !orderDiscount.subtractPoint ||
              orderDiscount.subtractPoint <= 0
            "
          >
            <i v-if="isApplyingPoints" class="fas fa-spinner fa-spin"></i>
            <i v-else class="fas fa-sync"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <small v-if="appliedPointsInfo" class="text-success mt-1 d-block">
        <i class="fas fa-check-circle"></i>
        Đã áp dụng {{ appliedPointsInfo.pointsUsed }} điểm - Giảm
        {{ formatCurrency(appliedPointsInfo.discountAmount) }}
      </small>
      <small v-if="pointsValidationError" class="text-danger mt-1 d-block">
        <i class="fas fa-exclamation-circle"></i>
        {{ pointsValidationError }}
      </small>
    </b-form-group>
    <b-form-group>
      <label for="input-name">Ngày hẹn thanh toán:</label>
      <div class="input-group">
        <date-picker
          placeholder="Ngày hẹn thanh toán"
          class="form-control-sm input-style"
          :config="dpConfigs.date"
          v-model="orderDiscount.paymentDate"
          :wrap="true"
        ></date-picker>
        <div class="input-group-append">
          <button
            class="btn btn-secondary btn-sm datepickerbutton"
            type="button"
            title="Toggle"
          >
            <i class="far fa-calendar"></i>
          </button>
        </div>
      </div>
    </b-form-group>
    <b-form-group>
      <label for="input-name">Phí vận chuyển thu của khách</label>
      <b-form-input
        class="input-style text-right"
        size="sm"
        type="text"
        v-model="orderDiscount.customerShipFee"
        placeholder="Phí vận chuyển thu của khách"
        v-mask="mask"
      ></b-form-input>
    </b-form-group>
    <b-form-group>
      <label for="input-name">Phí trả hãng vận chuyển</label>
      <b-form-input
        class="input-style text-right"
        size="sm"
        type="text"
        v-model="orderDiscount.shipFee"
        placeholder="Phí trả hãng vận chuyển"
        v-mask="mask"
      ></b-form-input>
    </b-form-group>
    <b-form-group v-if="orderInfo.orderId">
      <!-- <template slot="label">&nbsp;</template> -->
      <b-card no-body class="mt-2">
        <b-card-header
          style="padding: 10px 7px 3px 10px; background-color: #f1f1f1"
        >
          <div class="d-flex">
            <i class="fas fa-history mr-2" style="padding-top: 0.5px"></i>
            <h6>Lịch sử</h6>
          </div>
        </b-card-header>
        <b-card-body class="p-1 pb-0">
          <b-table-simple responsive id="history-table">
            <b-tbody v-for="(history, index) in histories" :key="index">
              <b-tr>
                <b-td style="width: 50%">
                  <b style="font-size: 1rem">{{ history.createdByName }}</b>
                  <span style="font-size: 10px">{{ history.createdAt }}</span>
                </b-td>
                <b-td style="width: 50%">
                  <a
                    href="#"
                    class="text-primary"
                    @click.prevent="openHistoryModal(history.id)"
                  >
                    {{ history.actionName }}
                  </a>

                  <span v-if="history.action === 3" style="font-size: 0.85em">
                    {{ history.newValue.statusName }}
                  </span>
                  <span v-else style="font-size: 0.85em">
                    <span
                      v-if="
                        history.originalValue.status !== history.newValue.status
                      "
                    >
                      {{ history.originalValue.statusName }}
                      ->
                      {{ history.newValue.statusName }}
                    </span>
                  </span>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-link
            href="#"
            class="float-right"
            @click="onClickHandoverHistory"
            v-if="historyDraft.length > 3"
            >Xem thêm</b-link
          >
        </b-card-body>
      </b-card>
    </b-form-group>

    <OrderHistoryModal
      :show="showHistoryModal"
      :history-id="selectedHistoryId"
      @update:show="showHistoryModal = $event"
      @open-modal="handleOpenModalFromUrl"
    />
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import datePicker from 'vue-bootstrap-datetimepicker';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import jQuery from 'jquery';
import Swal from 'sweetalert2';
const VoucherRepository = RepositoryFactory.get('vouchers');

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle',
  },
});
import { currencyMask, makeToastFaile, makeToastSuccess } from '@/utils/common';
import { AMOUNT_TYPE, ITEM_TYPE } from '@/utils/enum';
import timeUtils from '@/utils/date';
import { mapGetters } from 'vuex';
import { SET_ORDER_DISCOUNT_INFO } from '@/core/services/store/modules/order/order-discount.module.js';
import { ORDER_STATUS } from '@/utils/constants';
import moment from 'moment';
import { commonMixin } from '@/view/mixins/';
import OrderHistoryModal from './OrderHistoryModal.vue';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import CustomerPointRepository from '@/repositories/CustomerPointRepository';

export default {
  props: {
    action: String,
  },
  mixins: [commonMixin],
  data() {
    return {
      orderDiscount: null,
      selectDiscountType: 1,
      stateCouponCode: null,
      selectTypeSearch: 1,
      listTypeSearch: [
        {
          id: 1,
          name: 'Tìm sản phẩm',
        },
        {
          id: 2,
          name: 'Tìm sản phẩm imei',
        },
      ],
      searchProduct: null,
      filteredOptionsProduct: [],
      mask: currencyMask,
      listOrderItem: [],
      id: null,
      dpConfigs: null,
      histories: [],
      orderInfo: null,
      customerInfo: null,

      historyDraft: [],
      showHistoryModal: false,
      selectedHistoryId: null,
      isCheckingCoupon: false,
      isCouponApplied: false,
      appliedCouponInfo: null,
      appliedPointsInfo: null,
      pointsValidationError: null,
      POINT_TO_MONEY_RATE: 1000,
      isApplyingPoints: false,
    };
  },
  components: {
    datePicker,
    OrderHistoryModal,
  },
  watch: {
    orderDiscount: {
      handler: function (newValue) {
        this.$store.dispatch(SET_ORDER_DISCOUNT_INFO, newValue);
      },
      deep: true,
    },
  },
  created() {
    this.dpConfigs = timeUtils.DP_CONFIG;

    this.orderDiscount = this.getOrderDiscount;

    const discountType =
      this.getOrderDiscount.discountType || AMOUNT_TYPE.MONEY;
    this.selectDiscountType = discountType;

    this.orderInfo = this.getOrderInfo;
    this.customerInfo = this.getOrderCustomerInfo;

    if (this.action === 'update') {
      this.fetchOrderHistory(this.orderInfo.orderId);
    }
  },
  mounted() {
    this.checkModalFromUrl();
  },
  computed: {
    ...mapGetters([
      'getOrderDiscount',
      'getOrderInfo',
      'getOrderCustomerInfo',
      'getProducts',
    ]),
  },
  methods: {
    fetchOrderHistory: function (orderId) {
      const params = {
        //  loại đơn hàng
        type: 1,
        orderBy: ['createdAt', 'DESC'],
      };
      ApiService.query('/v1/histories/getByReferenceId/' + orderId, {
        params,
      }).then((response) => {
        response.data.data.map((item) => {
          const data = {
            ...item,
            originalValue: item.originalValue || null,
            newValue: item.newValue || null,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            updatedAt: moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
          };
          const items = [data.originalValue, data.newValue];

          items.map((element) => {
            if (element && element.status) {
              const listStatus = ORDER_STATUS.reduce((result, current) => {
                if (current.checked === false) {
                  current.value = Number(current.value);
                  result.push(current);
                }
                return result;
              }, []);
              element.statusName = null;
              const status = listStatus.find(
                (x) => +x.value === +element.status,
              );
              if (status) element.statusName = status.text;
            }
          });
          if (this.histories.length < 3) {
            this.histories.push(data);
          }
          this.historyDraft.push(data);
        });
      });
    },
    onChangeDiscountAmount: async function () {
      if (this.isCouponApplied && this.orderDiscount.couponCode) {
        const text = `Chỉnh sửa chiết khấu sẽ hủy mã coupon đã áp dụng`;
        const alert = await this.showWarningAlert(text);

        if (alert.isConfirmed) {
          this.removeCoupon();
        } else {
          this.$nextTick(() => {
            if (this.appliedCouponInfo) {
              // This will be handled by the coupon applied amount
            }
          });
        }
      }
    },
    onChangeDiscountType() {
      this.selectDiscountType =
        this.selectDiscountType === AMOUNT_TYPE.PERCENT
          ? AMOUNT_TYPE.MONEY
          : AMOUNT_TYPE.PERCENT;
      this.orderDiscount.discountType = this.selectDiscountType;
    },
    onChangeSubtractPoint: async function () {
      if (this.orderDiscount.subtractPointAmount) {
        const text = `Chỉnh sửa lại tiêu điểm sẽ xác nhận lại mã otp`;

        const alert = await this.showWarningPointAlert(text);
        if (alert.isConfirmed) {
          this.orderDiscount.otpCode = null;
          this.orderDiscount.subtractPointAmount = null;
          return;
        } else {
          this.orderDiscount.subtractPoint = this.subtractPointTerm;
        }
      }
    },
    onChangeCouponCode() {
      if (!this.orderDiscount.couponCode) {
        this.removeCoupon();
        return;
      }
      if (this.isCouponApplied) {
        this.removeCoupon();
      }
    },
    removeCoupon() {
      this.isCouponApplied = false;
      this.appliedCouponInfo = null;
      this.orderDiscount.discountAmount = 0;
      this.orderDiscount.discountType = 1;
      this.selectDiscountType = 1;
      if (!this.orderDiscount.couponCode) {
        this.orderDiscount.couponCode = null;
      }
    },
    checkCoupon: async function () {
      const products = this.getProducts;
      if (!products || !products.length) {
        makeToastFaile(`Vui lòng chọn sản phẩm`);
        return;
      }

      if (!this.orderDiscount.couponCode) {
        makeToastFaile(`Vui lòng nhập mã coupon`);
        return;
      }

      if (this.orderDiscount.discountAmount && !this.isCouponApplied) {
        const text = `Sử dụng mã coupon ${this.orderDiscount.couponCode} thay cho chiết khấu`;

        const alert = await this.showWarningAlert(text);

        if (!alert.isConfirmed) {
          this.orderDiscount.couponCode = null;
          return;
        }
      }

      this.isCheckingCoupon = true;

      try {
        const totalAmount = products.reduce((sum, product) => {
          const itemType = product.itemType;
          if (itemType !== ITEM_TYPE.GIFT) {
            return sum + product.sellingPrice * product.quantity;
          }
          return sum;
        }, 0);

        const response = await VoucherRepository.validateCoupon({
          couponCode: this.orderDiscount.couponCode,
          storeId: this.orderInfo.storeId,
          customerId: this.customerInfo.customerId,
          products,
          totalAmount,
        });
        if (response.status === 1) {
          makeToastSuccess(response.message);
          this.orderDiscount.discountAmount = response.data.discountAmount;
          this.orderDiscount.discountType = response.data.discountType;
          this.isCouponApplied = true;
          this.appliedCouponInfo = response.data.couponInfo;
        } else {
          this.orderDiscount.couponCode = null;
          makeToastFaile(response.message);
        }
      } catch (error) {
        makeToastFaile('Có lỗi xảy ra khi kiểm tra mã coupon');
        console.error('Coupon validation error:', error);
      } finally {
        this.isCheckingCoupon = false;
      }
    },

    onPointsInput() {
      this.pointsValidationError = null;
      this.appliedPointsInfo = null;
      this.orderDiscount.subtractPointAmount = null;
    },
    async applyCustomerPoints() {
      this.pointsValidationError = null;
      this.appliedPointsInfo = null;

      const pointsToUse = parseInt(this.orderDiscount.subtractPoint) || 0;

      if (pointsToUse <= 0) {
        this.pointsValidationError = 'Điểm không hợp lệ';
        return;
      }

      if (!this.customerInfo.totalPoint) {
        this.pointsValidationError = 'Khách hàng không có điểm khả dụng';
        return;
      }

      if (pointsToUse > this.customerInfo.totalPoint) {
        this.pointsValidationError = `Bạn chỉ có ${this.customerInfo.totalPoint} điểm`;
        return;
      }

      this.isApplyingPoints = true;

      try {
        const validationResponse = await CustomerPointRepository.validatePoints(
          this.customerInfo.customerId,
          pointsToUse,
        );

        const { discountAmount, pointToMoneyRate } = validationResponse;

        this.orderDiscount.subtractPointAmount = discountAmount;
        this.appliedPointsInfo = {
          pointsUsed: pointsToUse,
          discountAmount: discountAmount,
          pointToMoneyRate: pointToMoneyRate,
        };

        makeToastSuccess(
          `Áp dụng thành công ${pointsToUse} điểm - Giảm ${this.formatCurrency(
            discountAmount,
          )}`,
        );
      } catch (error) {
        this.pointsValidationError =
          error?.response?.data?.message || 'Có lỗi xảy ra khi áp dụng điểm';
        console.error('Error applying points:', error);
      } finally {
        this.isApplyingPoints = false;
      }
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      }).format(amount);
    },

    showWarningAlert: function (text) {
      return Swal.fire({
        title: 'Sử dụng chiết khấu!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    showWarningPointAlert: function (text) {
      return Swal.fire({
        title: 'Sử dụng điểm!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    onClickHandoverHistory() {
      this.histories = this.historyDraft;
    },
    openHistoryModal(historyId) {
      this.selectedHistoryId = historyId;
      this.showHistoryModal = true;
    },
    handleOpenModalFromUrl(historyId) {
      this.selectedHistoryId = historyId;
      this.showHistoryModal = true;
    },
    checkModalFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const modal = urlParams.get('modal');
      const historyId = urlParams.get('id');

      if (modal === 'order-history' && historyId) {
        this.openHistoryModal(historyId);
      }
    },
  },
};
</script>
<style scoped>
#history-table tbody tr td > span {
  display: block;
}
#history-table th,
td {
  padding: 0.3rem;
}
#history-table tbody tr td > b {
  width: max-content;
}
</style>
